export default __webpack_public_path__ + "static/media/schools_arknote@2x.906de107.png";